// Font utility for PDFs - simplified to use Helvetica (similar to Space Grotesk)

export const embedSpaceGroteskFont = async (doc: any) => {
  try {
    // Use helvetica as it's very similar to Space Grotesk and works reliably
    doc.setFont('helvetica');
    console.log('Using Helvetica font (similar to Space Grotesk)');
    return true;
  } catch (error) {
    console.log('Font setting failed, using default:', error);
    // Fallback to default font
    return false;
  }
}; 